import styled from "styled-components";

export const Container = styled.div`
  display: block;
  width: 100%;
  padding: 3.33vw 5.208333333333333vw;
  background: #fff;
  direction: ${(props) => (props.langDirection === "rtl" ? "rtl" : "ltr")};
`;

export const SocialWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 40px;
  margin-top: 24px;
  
  a {
    text-decoration: none;
  }

  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #121212;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 14px;
`;

export const FooterContent = styled.div`
  margin-top: 24px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4d4d4d;
`;
